/**
 * @file ProPill.jsx
 * @description The one muted-gold PRO pill (Insights tabs, dashboard nav, Provider Pool, account menu).
 *   It only labels the tier; callers decide when to show it (always, or only on Starter).
 * @module components/ui/ProPill
 */
import { T } from "../../theme";

export const PRO_PILL_STYLE = Object.freeze({
  fontSize: 9, fontWeight: 800, letterSpacing: "0.05em", fontFamily: T.fontBody,
  background: "#FFF8E1", color: "#B58A3A", border: "1px solid #E8D696",
  padding: "1px 5px", borderRadius: 4, lineHeight: 1.4, flexShrink: 0,
});

export default function ProPill({ style, ...rest }) {
  return <span {...rest} style={style ? { ...PRO_PILL_STYLE, ...style } : PRO_PILL_STYLE}>PRO</span>;
}
